import * as Constants from '../constants/product';

const initialState = {
  activeProduct: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_PRODUCT_SUCCESS:
      return {
        ...state,
        activeProduct: action.payload,
      };
    case Constants.SET_PRODUCT:
      return {
        ...state,
        activeProduct: action.payload,
      };
    default:
      return state;
  }
};
